import { GameManager } from "../GameManager"; 

export class BootScene extends Phaser.Scene {

    public static currentInstance: BootScene;
    
    constructor() {

        super("BootScene");
    }

    public preload(): void {

        this.load.image("bg_2", "assets/bg_02.png");
    }

    public create(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "HelveticaNeue", fontSize: 28, color: "#A6F834" });

        BootScene.currentInstance = this;
        GameManager.setCurrentScene(this);

        this.scene.setVisible(false);

        GameManager.init();
    }
}
